import { createContext, useContext, useEffect, useState } from "react";
import { Route, Routes } from "react-router-dom";
import Lenis from "lenis";
import "lenis/dist/lenis.css";
import "css/texts.css";
import "css/buttons.css";
import "css/components.css";
import { FadeInSection } from "components/general/FadeInSection";
import Footer from "components/general/Footer";
import Home from "routes/Home";
import ContactUs from "routes/ContactUs";
import PrivacyPolicy from "routes/PrivacyPolicy";
import TermsConditions from "routes/TermsAndConditions";
import TopBar from "components/general/TopBar";
import AiRisk from "routes/AiRisk";
import BlogPage from "components/home/BlogPage";

const LenisContext = createContext(null);
export const useLenis = () => useContext(LenisContext);

export default function App() {
  const [lenis, setLenis] = useState(null);

  useEffect(() => {
    const instance = new Lenis({
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });
    setLenis(instance);

    function raf(time) {
      instance.raf(time);
      requestAnimationFrame(raf);
    }
    requestAnimationFrame(raf);

    return () => instance.destroy();
  }, []);

  return (
    <LenisContext.Provider value={lenis}>
      <div style={{ position: "relative" }}>
        <TopBar />

        <div
          style={{
            marginTop: "75px",
          }}
        >
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/contact-us" element={<ContactUs />} />
            <Route path="/ai-risk" element={<AiRisk />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-and-conditions" element={<TermsConditions />} />
            <Route path="/blog/:slug" element={<BlogPage />} />
            <Route path="/:slug" element={<BlogPage />} />
          </Routes>
        </div>

        <FadeInSection>
          <Footer />
        </FadeInSection>
      </div>
    </LenisContext.Provider>
  );
}
